import { FC, ChangeEvent, FocusEvent, CSSProperties, KeyboardEvent } from "react";
import classes from "./style.module.scss";
import date_icon from "../../../assets/images/date_icon.svg";

const Input: FC<{
  label?: string;
  palceholder?: string;
  type?: string;
  required?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onCopy?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onCut?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  value?: string | number;
  style?: CSSProperties;
  inputStyle?: CSSProperties;
  allowNegativeNumber?: boolean;
  className?: string;
  icon?: { className?: string };
  disabled?: boolean;
  autoComplete?: string;
  fromSupplyTab?: boolean;
  showCalendarIcon?: boolean;
  decimalCount?: number;
  maxLength?: number;
  minLength?: number;
}> = ({
  onPaste,
  onCopy,
  onCut,
  onKeyDown,
  label,
  palceholder,
  type,
  required,
  onChange,
  onFocus,
  onBlur,
  allowNegativeNumber,
  style,
  inputStyle = {},
  value,
  className,
  icon,
  disabled,
  autoComplete,
  fromSupplyTab,
  showCalendarIcon = false,
  decimalCount = 2,
  maxLength,
  minLength
}) => {
    return (
      <>
        <div className={`relative ${classes.inputContainer} ${className}`} style={style}>
          {label !== "" && (
            <label className="fs-14">
              {label}{" "}
              <span className="color-red">{required === true && "*"}</span>
            </label>
          )}
          <input
            type={type || "text"}
            className={`mt-[8px] w-full px-3.5 py-2 br-10 fs-14 ${disabled ? "bg-[#F4F4F4] cursor-not-allowed" : "bg-white"
              } ${fromSupplyTab ? "" : "border"} focus:border-green-500 `}
            style={inputStyle}
            placeholder={palceholder || ""}
            onWheel={(e) => (e.target as HTMLElement).blur()}
            autoComplete={autoComplete || ""}
            minLength={minLength}
            maxLength={type !== "number" ? maxLength : undefined}
            onChange={(e) => {
              if (!onChange) {
                return;
              }
              if (type === "number") {
                if (maxLength && e.target.value.replace("-", "").length > maxLength) {
                  return;
                }

                const decimalLimit = decimalCount;

                let regexp = new RegExp(`^[0-9]*(\\.[0-9]{0,${decimalLimit}})?$`);

                if (allowNegativeNumber) {
                  regexp = new RegExp(`^-?[0-9]*(\\.[0-9]{0,${decimalLimit}})?$`);
                }

                if (regexp.test(e.target.value)) {
                  onChange(e);
                }
              } else {
                onChange(e);
              }
            }}
            onKeyDown={onKeyDown}
            onPaste={onPaste}
            onCopy={onCopy}
            onCut={onCut}
            onFocus={onFocus}
            value={value}
            disabled={disabled}
          />
          {showCalendarIcon && (
            <img src={date_icon} alt="" className="absolute top-11 right-3 h-5 w-5 pointer-events-none" />
          )}
        </div>
      </>
    );
  };
export default Input;
